import { Component, EventEmitter, Input, Output, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { DataService } from 'src/app/core/config/app.config';
import { UploadFileRepository } from 'src/app/core/repositories/uploadfile.repository';

@Component({
    selector: 'digi-file-upload-image',
    templateUrl: './input-file-image.component.html',
    styleUrl: './input-file-image.component.scss'
})
export class InputFileImageComponent implements OnDestroy {
    @Input() text: string = 'LABEL.FILEDINHKEM'
    @Input() isNecessary : boolean = false
    @Input() accept: string = '.png, .jpg, .jpeg, .gif, .bmp, .svg' // Những định dạng file được phép tải lên 
    @Input() control!: FormControl;           // FormControl để quản lý giá trị và trạng thái
    @Input() isMultiple: boolean = false
    @Input() errMessage: string = ''
    @Input() type: number = 1
    @Input() selectedFiles: any[] = [];
    // Mặc định giữ hành vi cũ: tự động upload. Trang nhân viên sẽ set false để trì hoãn.
    @Input() autoUpload: boolean = true;
    @Output() selectedFilesChange = new EventEmitter<any>();
    // Emit when user clicks on a preview image thumbnail
    @Output() previewClick = new EventEmitter<string>();

    protected ngUnsubscribeHttp: Subject<void> = new Subject<void>();
    private blobUrlCache = new Map<File, string>(); // Cache để lưu blob URLs

    constructor(
        public uploadFileRepository: UploadFileRepository,
        private cdr: ChangeDetectorRef
    ){}
    onFileSelected(event: any): void {
        const files: FileList = event.target.files;
        if (this.autoUpload) {
          const formData: FormData = new FormData();
          for (let i = 0; i < files.length; i++) {
            const file = files[i];
            formData.append('files', file, file.name);
          }
          this.uploadFileRepository.uploadFileImageToS3(formData).pipe(takeUntil(this.ngUnsubscribeHttp))
          .subscribe((res) => {
              if (res.data && res.meta?.error_code === 200) {
                const uploaded = res.data.map((item: string) => ({ FileName: item }));
                switch(this.isMultiple){
                  case true:
                    this.selectedFiles = [...this.selectedFiles, ...uploaded.map((item: any) => item.FileName)];
                    break;
                  case false:
                    this.selectedFiles = [...uploaded.map((item: any) => item.FileName)];
                    break;
                }
                this.control.setValue(this.selectedFiles);
                this.selectedFilesChange.emit(this.selectedFiles);
              }
            });
        } else {
          const picked: File[] = [];
          for (let i = 0; i < files.length; i++) {
            picked.push(files[i]);
          }
          switch(this.isMultiple){
            case true:
              // Append newly picked files to existing list
              this.selectedFiles = [...this.selectedFiles, ...picked];
              break;
            case false:
              // Replace with the last picked file
              this.selectedFiles = picked.length ? [picked[picked.length - 1]] : [];
              break;
          }
          // Store raw File objects in control for parent to upload on submit
          this.control.setValue(this.selectedFiles);
          this.selectedFilesChange.emit(this.selectedFiles);
        }
      }
      public openFilePicker(fileInput: HTMLInputElement): void {
        fileInput.value = '';
        fileInput.click();
    }
      removeFile(index: number): void {
        this.selectedFiles.splice(index, 1);
        this.control.setValue(this.selectedFiles)
        this.selectedFilesChange.emit(this.selectedFiles);
      }

      getImageUrl(file: any): string {
        // Support both previewing existing URLs/filenames and newly picked File objects
        if (typeof file === 'string') {
          if (file.startsWith('http')) {
            return file;
          }
          // Use the S3 view URL from app config
          return `${DataService.API_URL_BASE_VIEW_S3}?fileName=${file}`;
        }
        if (file instanceof File || (file && (file as any).name && (file as any).size)) {
          const fileObj = file as File;
          // Kiểm tra cache trước khi tạo blob URL mới
          if (this.blobUrlCache.has(fileObj)) {
            return this.blobUrlCache.get(fileObj)!;
          }
          // Tạo blob URL mới và cache nó
          const blobUrl = URL.createObjectURL(fileObj);
          this.blobUrlCache.set(fileObj, blobUrl);
          return blobUrl;
        }
        return '';
      }

      onPreviewClick(file: any) {
        const url = this.getImageUrl(file);
        if (url) {
          this.previewClick.emit(url);
        }
      }

      trackByFile(index: number, file: any): any {
        // Sử dụng tên file và kích thước để tạo unique key
        if (file instanceof File) {
          return `${file.name}-${file.size}-${file.lastModified}`;
        }
        return typeof file === 'string' ? file : index;
      }

      ngOnDestroy(): void {
        // Cleanup blob URLs để tránh memory leak
        this.blobUrlCache.forEach((url) => {
          URL.revokeObjectURL(url);
        });
        this.blobUrlCache.clear();
        this.ngUnsubscribeHttp.next();
        this.ngUnsubscribeHttp.complete();
      }
}